import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import { getFormattedDisplayNameForEqlField } from '@modules/common/components/EqlFieldsAutoComplete/helpers';
import { LoadingTypography } from '@modules/common/components/LoadingTypography';
import {
  useIsUnifiedFieldsEnabled,
  useShouldRemoveFileUploadPrefix,
} from '@modules/common/hooks';
import { MeasuredAsPreview } from '@modules/quantify/components/QuantifyQueryBuilder/QuantifyQueryBuilderPreview/MeasuredAsPreview';
import { WhereClauseFilterPreview } from '@modules/quantify/components/QuantifyQueryBuilder/QuantifyQueryBuilderPreview/WhereClauseFilterPreview';
import { QuantifyActionType } from '@modules/quantify/store/quantifyActionType';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { Divider, Stack, Typography } from '@mui/material';
import { DurationPreview } from './DurationPreview';

export function QuantifyQueryBuilderPreview() {
  const dispatch = useQuantifyStore(({ dispatch }) => dispatch);
  const query = useQuantifyStore(({ query }) => query);
  const isLoading = useAnalysisStore(({ isLoading }) => isLoading);
  const shouldRemoveFileUploadPrefix = useShouldRemoveFileUploadPrefix();
  const isUnifiedFieldEnabled = useIsUnifiedFieldsEnabled();

  function expandQueryBuilder() {
    dispatch({
      type: QuantifyActionType.SET_VISUAL,
      payload: {
        isEditMode: true,
      },
    });
  }

  return (
    <Stack spacing={2} width={300} onClick={expandQueryBuilder} p={2}>
      <Stack spacing={2}>
        <Stack spacing={2}>
          <Stack>
            <Typography variant="subtitle1">Show me:</Typography>
            <LoadingTypography
              variant="body2"
              color="primary"
              skeletonWidth="100%"
              isLoading={isLoading}
            >
              {query.groupByField
                ? getFormattedDisplayNameForEqlField({
                    eqlField: query.groupByField,
                    shouldRemoveFileUploadPrefix,
                    isUnifiedFieldEnabled,
                  })
                : '--'}
            </LoadingTypography>
          </Stack>
          <Divider />
        </Stack>
        <Stack spacing={2}>
          <WhereClauseFilterPreview />
          <Divider />
        </Stack>
        <Stack spacing={2}>
          <DurationPreview />
          <Divider />
        </Stack>
        <Stack spacing={2}>
          <MeasuredAsPreview />
          <Divider />
        </Stack>
      </Stack>
    </Stack>
  );
}
